import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LandingPageComponent } from "../feature/user/components/home/landing-page/landing-page.component";

const routes: Routes = [
	{
		path: "",
		component: LandingPageComponent,
		children: []
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class SharedRoutingModule {}
